module.exports = __webpack_public_path__ + "img/main-technical.e0729b5f.jpg";